export const whyDCExampleData = [
  { heading: "More contest entries", description: "With over 200,000 designers at DC, you receive more design entries & greater creativity." },
  {
    heading: "Pre-qualified designers",
    description: "All the designers on our platform undergo qualification testing."
  },
  { heading: "Privacy option", description: "You can opt for NDA protection and have your contest hidden from search engines." },
  {
    heading: "100% money back guarantee",
    description: "You can request all of your money back at any stage of the process."
  },
  {
    heading: "1-on-1 projects",
    description: "Continue working with your favorite designer on your future projects or other design related tasks."
  },
  {
    heading: "Voting feature",
    description: "Get early feedback on your favorite design from your target audience, colleagues and friends."
  }
];
